import React from 'react'
import GetCompensationPublic from '../CartolaCompAndRelPublic/CartolaCompensationPublic'
import GetReliquidationPublic from '../CartolaCompAndRelPublic/CartolaReliquidationPublic'


const ControllerCompAndRelPublic = (
    { options,
        titleCompensation,
        titleReliquidation,
        textFetchError,
        descripcioneCompensationPublic,
        descripcioneReliquidationPublic,
        textAlertFilledField,
        setGlobalAlert }) => {

    const [loading, setLoading] = React.useState(false);

    const [toggleCurrentComponent,setToggleCurrentComponent] = React.useState('1')
    function handlePageRel() {
        setToggleCurrentComponent('1')
    }
    function handlePageComp() {
        setToggleCurrentComponent('2')
    }

    return (
        <div className="container-table">
            <nav>
                <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a onClick={handlePageRel} className="nav-link active pb-2" id="cartola-reliquidacion" data-toggle="tab" href="#cartolaRelComponent" role="tab" aria-controls="cartolaRelComponent" aria-selected="true" data-lineheight="30" data-fontsize="18" >{titleReliquidation}</a>
                    </li>

                    <li className="nav-item">
                        <a onClick={handlePageComp} className="nav-link pb-2" id="cartola-compensacion" data-toggle="tab" href="#cartolaCompenComponent" role="tab" aria-controls="cartolaCompenComponent" aria-selected="false" data-lineheight="30" data-fontsize="18" >{titleCompensation}</a>
                    </li>
                </ul>
            </nav>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="cartolaRelComponent" role="tabpanel" aria-labelledby="cartola-reliquidacion">
                    <GetReliquidationPublic
                        titleReliquidation={titleReliquidation}
                        descripcioneReliquidationPublic={descripcioneReliquidationPublic}
                        textFetchError={textFetchError}
                        toggleCurrentComponent={toggleCurrentComponent}
                        textAlertFilledField={textAlertFilledField}
                        loading={loading}
                        setGlobalAlert={setGlobalAlert}
                        setLoading={setLoading} /></div>
                <div class="tab-pane fade" id="cartolaCompenComponent" role="tabpanel" aria-labelledby="cartola-compensacion">
                    {<GetCompensationPublic
                        titleCompensation={titleCompensation}
                        options={options}
                        descripcioneCompensationPublic={descripcioneCompensationPublic}
                        textFetchError={textFetchError}
                        toggleCurrentComponent={toggleCurrentComponent}
                        textAlertFilledField={textAlertFilledField}
                        loading={loading}
                        setGlobalAlert={setGlobalAlert}
                        setLoading={setLoading} />}
                </div>

            </div>

        </div>
    )
}

export default ControllerCompAndRelPublic